import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';


const SingleSelectSearch = () => {

    const options = [
        'Hamad International Airport',
        'Tokyo Haneda International Airport',
        'Incheon International Airport',
        'Incheon International Airport',
    ];

    return (
        <div>
            
            <Autocomplete
                disablePortal
                options={options}
                sx={{
                    width: '100%',
                    fontSize: '12px',
                    '& .MuiInputBase-root': {
                    height: 50,
                    padding: 0,
                    },
                    '& .MuiInputBase-input': {
                    height: '40px',
                    boxSizing: 'border-box',
                    padding: '0 14px',
                    },
                    '& .MuiFormLabel-root': {
                    top: '-5px',
                    },
                    '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: '#ccc', 
                    },
                   
                    '&.Mui-focused fieldset': {
                        borderColor: '#2d65c7', 
                    },
                    },
                    '& label.Mui-focused': {
                    color: '#2d65c7',
                    },
                }}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    label="Airport"
                    variant="outlined"
                    sx={{ fontSize: '1px' }}
                    />
                )}
                />
        </div>
    )
}

export default SingleSelectSearch;